// extracted by mini-css-extract-plugin
export default {"thanksModal":"ThanksModal_thanksModal__CmP4a","thanks":"ThanksModal_thanks__kSF4U","message":"ThanksModal_message__orczZ"};